import type { RootState } from 'app/reducers/index.ts';
import { LoadingStatus } from 'app/store/types.ts';

function create<T>(selector: (state: RootState['globalAssetsLibrary']) => T): (state: RootState) => T {
  return (state: RootState) => selector(state.globalAssetsLibrary);
}

export const globalAssetsLibraryLoadingStatusSelector = create((s) => s.status);

export const categoriesSelector = create((s) => s.data);
export const isGlobalAssetsLibraryStatusLoadingSelector = create((s) => s.status === LoadingStatus.Loading);
export const isGlobalAssetsLibraryStatusSucceedSelector = create((s) => s.status === LoadingStatus.Succeeded);
export const isGlobalAssetsLibraryStatusNotIdleSelector = create((s) => s.status !== LoadingStatus.Idle);

// export const updatingGroupsSelector = create((s) => s.updatingGroups);
